import React, {Component} from "react"
import PropTypes from "prop-types"
import MaskedInput from 'react-text-mask'
import _ from "lodash"


export default class NRTCpfCnpjInput extends Component {


    componentDidMount() {
        this.input = React.createRef()
    }



    focus() {
        const input = _.get(this.input , 'current.inputElement')

        if (input )
            input.focus()

    }


    handleChange = (evt) => {
        this.props.onChange(evt.target.value)
    }


    render() {

        const num = /[0-9]/

        const mask = this.props.cpf ?
            [num, num, num, '.', num, num, num, '.', num, num, num, '-', num, num] :
            [num, num, '.', num, num, num, '.', num, num, num, '/', num , num, num, num, '-', num, num]

        return (
            <div className={'nrt-form-input'}>

                <MaskedInput
                    mask={mask}
                    ref={this.input}
                    {...this.props}
                    onChange={this.handleChange}
                />
            </div>
        )
    }
}

NRTCpfCnpjInput.propTypes = {
    /** Utilizar mascara de CPF, senao usa a de CNPJ */
    cpf: PropTypes.any,

    onChange: PropTypes.func,
    type: PropTypes.string,
}

NRTCpfCnpjInput.defaultProps = {
    cpf: true,
    type: 'text',
}



// WEBPACK FOOTER //
// ./src/components/_common/_form/FormInput/CpfCnpjInput/index.js